import React, { useState } from 'react';

import { WaypointFeatureTier } from '@dashboard/generated/wp/platform';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Stack, Typography } from '@mui/material';

import PlanCard from './PlanCard';

type Props = {
  planSelection: WaypointFeatureTier;
  onSubmit: (tier: WaypointFeatureTier) => void;
  onClose: () => void;
  loading: boolean;
};

export default function SelectPlanDialog({ planSelection, onSubmit, onClose, loading }: Props) {
  const [plan, setPlan] = useState<WaypointFeatureTier>(planSelection);
  const onSubmitHandler = () => {
    if (!plan) {
      return;
    }
    onSubmit(plan);
  };

  const renderCard = (tier: WaypointFeatureTier) => (
    <PlanCard onSelect={setPlan} tier={tier} isCurrent={planSelection == tier} isSelected={plan == tier} />
  );

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Manage plan</DialogTitle>
      <DialogContent>
        <Stack spacing={2} py={1}>
          <Typography>
            Learn more about Waypoint's different{' '}
            <Link href="https://www.usewaypoint.com/pricing" target="_blank">
              pricing plans and features
            </Link>
            .
          </Typography>
          {renderCard(WaypointFeatureTier.Free)}
          {renderCard(WaypointFeatureTier.Starter)}
          {renderCard(WaypointFeatureTier.Growth)}
          {renderCard(WaypointFeatureTier.Pro)}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onSubmitHandler} variant="contained" disabled={plan === planSelection || !plan || loading}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
